import { useMutation, useQueryClient } from '@tanstack/react-query'

import fileService from 'src/service/file-service'
import queries from 'src/queries'

import useToast from '../useToast'

import { MentorCloudFileFilters } from 'src/types/files/file'

export const useMentorCloudAddThumbnail = (filters: MentorCloudFileFilters) => {
  const queryClient = useQueryClient()
  const { notify } = useToast()

  const { mutate: addThumbnailMutation, isPending: isAddThumbnailPending } = useMutation({
    mutationFn: (value: { video_id: string; preview_file_id: string }) => {
      return fileService.addThumbnail(value)
    },
    onSuccess: async () => {
      notify('add', { type: 'success' })

      await queryClient.invalidateQueries({
        queryKey: queries.mentorCloud.files(null, filters).queryKey
      })
    },
    onError: err => notify(err.message || 'unexpected', { type: 'error' })
  })

  return {
    addThumbnailMutation,
    isAddThumbnailPending
  }
}
